import { Users, UserCheck, Clock, AlertTriangle, Ban } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';

interface AdminStatsCardsProps {
  total: number;
  active: number;
  trial: number;
  trialEnded: number;
  blocked: number;
  pending: number;
}

const stats = (p: AdminStatsCardsProps) => [
  { label: 'Total Users', value: p.total, icon: Users, color: 'text-foreground' },
  { label: 'Active', value: p.active, icon: UserCheck, color: 'text-green-600' },
  { label: 'Trial', value: p.trial, icon: Clock, color: 'text-blue-600' },
  { label: 'Trial Ended', value: p.trialEnded, icon: AlertTriangle, color: 'text-orange-500' },
  { label: 'Pending', value: p.pending, icon: Clock, color: 'text-muted-foreground' },
  { label: 'Blocked', value: p.blocked, icon: Ban, color: 'text-destructive' },
];

const AdminStatsCards = (props: AdminStatsCardsProps) => (
  <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 mb-6">
    {stats(props).map((s) => (
      <Card key={s.label} className="hover:shadow-md transition-shadow">
        <CardContent className="p-4 flex flex-col items-center text-center gap-1">
          <s.icon className={`h-5 w-5 ${s.color}`} />
          <span className="text-2xl font-bold">{s.value}</span>
          <span className="text-xs text-muted-foreground">{s.label}</span>
        </CardContent>
      </Card>
    ))}
  </div>
);

export default AdminStatsCards;
